import React, { MouseEventHandler, useContext } from "react";

import { BrWidgetOtherConfig } from "@features/live-widgets/shared";
import { EventContext } from "@gp/components";
import classnames from "classnames";

import { EventPageSubheaderCloseButton } from "./EventPageSubheaderCloseButton";
import { EventPageSubheaderTitle } from "./EventPageSubheaderTitle";
import { EventSwitcherButton } from "./EventSwitcherButton";

const isLMTEnabled = BrWidgetOtherConfig;

export function EventPageSubheader({
	onClose,
}: {
	onClose: MouseEventHandler<HTMLButtonElement>;
}) {
	const event = useContext(EventContext);

	const headerClasses = classnames("event__header", {
		"event__header--borderless": !isLMTEnabled,
	});

	return (
		<div className={headerClasses}>
			<nav className="header--event">
				<EventPageSubheaderTitle />
				<div className="event__header__actions">
					<EventSwitcherButton eventId={event.id} direction="left" />
					<EventSwitcherButton eventId={event.id} direction="right" />
				</div>
				<EventPageSubheaderCloseButton onClick={onClose} />
			</nav>
		</div>
	);
}
